<span class="disabled-button-reason"
      [class.disabled-button-reason--active]="hasReason"
      [attr.aria-disabled]="disabled ? 'true' : null"
      [attr.tabindex]="hasReason ? '0' : null"
      [matTooltip]="hasReason ? reason : ''"
      [matTooltipDisabled]="!hasReason"
      [matTooltipPosition]="position">
  <ng-content></ng-content>
</span>
